module.exports = "/dist/57af64fc644194101c1593abea164433.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-500.woff
// module id = 156
// module chunks = 0